import { SocialLoginButtons } from "@/components/auth/SocialLoginButtons";
import {
  PrecisionGear,
  PressureGauge,
  HexBolt,
  MeasureScale,
  Wrench,
  DialKnob,
} from "@/components/login/MechanicalIcons";
import "@/styles/LoginPage.css";

export function LoginPage() {
  return (
    <div className="login-page safe-area-top safe-area-bottom">
      <div className="blueprint-grid relative flex h-full flex-col items-center justify-center overflow-hidden px-6">
        {/* 배경 기계 요소들 */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          {/* 왼쪽 상단 기어 시스템 */}
          <div className="absolute" style={{ top: -60, left: -80 }}>
            <PrecisionGear size={220} teeth={16} className="gear-spin text-slate-200" />
          </div>
          <div className="absolute" style={{ top: 75, left: 55 }}>
            <PrecisionGear size={100} teeth={10} className="gear-spin-reverse text-slate-300/70" />
          </div>

          {/* 오른쪽 하단 기어 */}
          <div className="absolute" style={{ bottom: -50, right: -60 }}>
            <PrecisionGear size={180} teeth={14} className="gear-spin-slow text-slate-200" />
          </div>
          <div className="absolute" style={{ bottom: 60, right: 50 }}>
            <PrecisionGear size={70} teeth={8} className="gear-spin text-slate-300/60" />
          </div>

          {/* 게이지 - 왼쪽 */}
          <div className="absolute" style={{ bottom: "18%", left: "3%" }}>
            <PressureGauge size={90} className="text-slate-300/50 scale-in" needleAngle={-30} />
          </div>

          {/* 육각 볼트들 */}
          <HexBolt
            size={40}
            className="absolute text-slate-300/30 pulse-subtle"
            style={{ top: "25%", left: "8%" }}
          />
          <HexBolt
            size={30}
            className="absolute text-slate-300/25"
            style={{ top: "45%", right: "6%" }}
          />
          <HexBolt
            size={35}
            className="absolute text-slate-300/20"
            style={{ bottom: "30%", left: "12%" }}
          />
          <HexBolt
            size={25}
            className="absolute text-slate-300/30 pulse-subtle"
            style={{ top: "60%", right: "10%" }}
          />

          {/* 측정 스케일 */}
          <MeasureScale
            width={100}
            height={16}
            className="absolute text-slate-300/30"
            style={{ bottom: "40%", right: "2%", transform: "rotate(-90deg)" }}
          />

          {/* 렌치 - 오른쪽 상단 영역 */}
          <Wrench
            size={50}
            className="absolute text-slate-300/35"
            style={{ top: "15%", right: "6%", transform: "rotate(30deg)" }}
          />

          {/* 다이얼 노브 - 오른쪽 중상단 영역 */}
          <DialKnob
            size={60}
            className="absolute text-slate-300/30"
            style={{ top: "28%", right: "15%" }}
            rotation={-45}
          />

          {/* 코너 장식 - 기술 도면 스타일 */}
          <svg
            className="absolute text-slate-300/40"
            style={{ top: 20, left: 20 }}
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
          >
            <path d="M0 60 L0 20 L5 20 L5 55 L60 55 L60 60 Z" fill="currentColor" />
            <circle cx="15" cy="45" r="3" fill="currentColor" />
          </svg>
          <svg
            className="absolute text-slate-300/40"
            style={{ bottom: 20, right: 20, transform: "rotate(180deg)" }}
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
          >
            <path d="M0 60 L0 20 L5 20 L5 55 L60 55 L60 60 Z" fill="currentColor" />
            <circle cx="15" cy="45" r="3" fill="currentColor" />
          </svg>
        </div>

        {/* 메인 콘텐츠 */}
        <div className="relative z-10 w-full max-w-[340px]">
          {/* 타이틀 */}
          <div className="text-center mb-10 fade-up-1">
            <div className="inline-flex items-center gap-2 mb-3">
              <div className="w-8 h-[2px] bg-cyan-500" />
              <span className="text-[10px] font-semibold tracking-[0.2em] text-cyan-600 uppercase">
                Equipment Inspection
              </span>
              <div className="w-8 h-[2px] bg-cyan-500" />
            </div>
            <h1
              className="text-[28px] font-bold tracking-tight"
              style={{ color: "var(--color-primary)" }}
            >
              ICT 설비점검
            </h1>
            <p
              className="mt-2 text-xs tracking-[0.15em] uppercase"
              style={{ color: "var(--color-secondary)" }}
            >
              System Login v1.0
            </p>
          </div>

          {/* 소셜 로그인 */}
          <div className="fade-up-2">
            <SocialLoginButtons />
          </div>
        </div>

        {/* 하단 정보 */}
        <div
          className="absolute bottom-5 flex items-center gap-3 text-[10px] tracking-wider uppercase"
          style={{ color: "var(--color-secondary)" }}
        >
          <span>v1.0.0</span>
          <span
            className="w-1 h-1 rounded-full"
            style={{ background: "var(--color-grid-accent)" }}
          />
          <span>Korea DCC</span>
          <span
            className="w-1 h-1 rounded-full"
            style={{ background: "var(--color-grid-accent)" }}
          />
          <span>© 2025</span>
        </div>
      </div>
    </div>
  );
}
